<template>
  <el-table v-if="settingType=='FQC'" stripe border style="width: 100%" height="100%" size="mini"
      :data="tableData" @sort-change="sortChange"
    >
      <el-table-column type="index" align="center"
        :width="pagination.endIndex >= 1000 ? 80 : 50"
        :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column width="140px" 
        label="检验单号" align="center" prop="orderNumber" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="allowSkip" @click="clickAllowSkip(scope.row)">
            {{ scope.row.orderNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column max-width="110px" 
        label="生产工单" prop="originalOrder" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.product" class="item expire" effect="dark" placement="top" :open-delay="300"
            :content="scope.row.product.code">
            <span v-if="scope.row.originalOrder">
              {{ scope.row.originalOrder.orderNumber }}
            </span>
            <span v-else>-</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column min-width="50px" 
        label="送检数量" prop="batchQuantity" align="center" show-overflow-tooltip 
      >
        <template slot-scope="scope">
          <span v-if="scope.row.batchQuantity">
            {{ scope.row.batchQuantity }} PCS
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column max-width="100px" 
        label="送检时间" prop="createDateTime" align="center" show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.createDateTime">
            {{ scope.row.createDateTime }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="送检员" prop="name" align="center" show-overflow-tooltip
        width="80px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.createUser">
            {{ scope.row.createUser.name }}({{ scope.row.createUser.employeeNum }})
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column min-width="50px" 
        label="检验数量" prop="checkSnList" align="center" show-overflow-tooltip 
      >
        <template slot-scope="scope">
          <span v-if="scope.row.checkQuantity">
            {{ scope.row.checkQuantity }} PCS
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column width="140px" 
        label="检验批次" prop="partLot" align="center" show-overflow
      >
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.checkDateTime" class="item expire" effect="dark" placement="top" :open-delay="300"
            :content="scope.row.checkDateTime">
            <span v-if="scope.row.partLot!='WAIT'">
              {{ scope.row.partLot }} 
            </span>
            <span v-else>-</span>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        label="检验员" prop="name" align="center" show-overflow-tooltip
        width="80px"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.checkUser">
            {{ scope.row.checkUser.name }}({{ scope.row.checkUser.employeeNum }})
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column min-width="50px" show-overflow-tooltip
        label="状态" prop="status" align="center"
      >
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.status && scope.row.status.code>0" class="item expire" effect="dark" placement="top" :open-delay="300"
            :class="scope.row.status.code==2 ? 'tiaojian' : 'fail'"
            :content="scope.row.failedRecordResultList.length>0 ? JSON.stringify(scope.row.failedRecordResultList) : 'QC判退'">
            <span v-if="scope.row.status">
              <i v-if="scope.row.status.code==2" class="el-icon-check"></i>
              <i v-else class="el-icon-close"></i>{{ scope.row.status.title }}
            </span>
            <span v-else>-</span>
          </el-tooltip>
          <span v-else-if="scope.row.status" :class="scope.row.status.code==0 ? 'pass_' : ''">                
              <i v-if="scope.row.status.code==0" class="el-icon-check"></i>{{ scope.row.status.title }} 
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column  class-name="operation" label="操作" align="center" width="70">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.status.code==-1" class="item" effect="dark" content="删除" placement="top" :open-delay="300">
            <i @click="deleteOrder($event, scope.row)" class="el-icon-delete"></i>
          </el-tooltip>
          <el-tooltip v-else-if="(scope.row.status.code==0 || scope.row.status.code==2) && !scope.row.storageDateTime" 
            class="item" effect="dark" content="返回送检前工序" placement="top" :open-delay="300">
            <i @click="backOrder($event, scope.row)" class="el-icon-refresh-left"></i>
          </el-tooltip>
          <span v-else>-</span>
        </template>        
      </el-table-column>
    </el-table>
</template>

<script>

import {
  apiQcCheckListDelete,
  apiQcCheckListSearch,
  apiQcOrderExport,
  apiQcUpdateStatus,
  apiQcBackCheck,
} from "@/api/qcOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    settingType:null,
    searchConditionForm:{type: Object},
    pagination:{},
    tabPaneList: {},
  },

  components: {
  },
  
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData:null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    deleteOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "检验单").then(
        async () => {
          const res = await apiQcCheckListDelete({
            id: row.id,
          });
          if (res.code == 0) {
            this.getFQCCheckListSearch();                
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    backOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "返回送检前工序", "检验单").then(
        async () => {
          const res = await apiQcBackCheck({
            id: row.id,
          });
          if (res.code == 0) {
            this.getFQCCheckListSearch();                
            this.$message({
              message: "成功返回送检前工序",
              type: "success",
            });
          }
        }
      );
    },
    addNewBtn() {
      this.dialogTitle = "新建送检单";
      this.$refs.myDialog.dialogVisible = true;
      this.getQcCheckListInit()
    },
    // 点击表格编号
    clickAllowSkip(row) {
      this.nowRowData = row;
      this.$parent.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 确认新建
    async submitData(title) {
        this.$refs.dialogForm.validate(async (valid) => {        
          if (valid) {
            let res = {};
            if (title == "重检") {
              res = await apiQcUpdateStatus({
                id:this.tabPaneValue,
                status:this.dialogForm.status
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getProductionOrderSearch();
                this.$message({
                  message: "开始",
                  type: "success",
                });
              }
          }
            
          }
        });
      
    },
    reCheck() {
      this.dialogTitle = "重检";
      this.$refs.myDialog.dialogVisible = true;
    }, 
    // 表格数据
    async getFQCCheckListSearch(remove) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      var status=null;
      if(this.searchConditionForm.status != null && this.searchConditionForm.status!="" && this.searchConditionForm.status!=undefined){
        status = [this.searchConditionForm.status];
      }
      const res = await apiQcCheckListSearch({
        ...this.searchConditionForm,
        status:status,
        type:"FQC",
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        
      }
    },
    // 检验单记录导出
    QCOrderExport() {
      this.$confirm(`请勿频繁导出！`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiQcOrderExport({
          ...this.inspectionForm,
          export: true,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      })
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getFQCCheckListSearch();
    },    
  },
};
</script>
<style lang="less" scoped>
.none_border {width:265px; margin: left 2px;; display: -moz-inline-box; display: inline-block;}

  .fail {
    color: #f56c6c;
  }
  .tiaojian {
    color: #e6a23c;
  }
  .pass_{
    color:#67C23A;
  }
</style>